var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsers = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 6.66659C11.4731 6.66659 12.667 5.47268 12.667 3.99992C12.667 2.52716 11.4731 1.33325 10.0003 1.33325M11.3337 14.6666H13.2003C14.3785 14.6666 15.3337 13.7115 15.3337 12.5333C15.3337 10.7659 13.901 9.33325 12.1337 9.33325H11.3337M8.00033 3.99992C8.00033 5.47268 6.80642 6.66659 5.33366 6.66659C3.8609 6.66659 2.66699 5.47268 2.66699 3.99992C2.66699 2.52716 3.8609 1.33325 5.33366 1.33325C6.80642 1.33325 8.00033 2.52716 8.00033 3.99992ZM2.80032 14.6666H7.86699C9.0452 14.6666 10.0003 13.7115 10.0003 12.5333C10.0003 10.7659 8.56764 9.33325 6.80033 9.33325H3.86699C2.09968 9.33325 0.666992 10.7659 0.666992 12.5333C0.666992 13.7115 1.62212 14.6666 2.80032 14.6666Z",
    stroke: "#8C8F9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsers);
export default ForwardRef;